import { differenceWith, indexOf, isEmpty, isEqual, without } from "lodash";

export default function toggleItemInArray<T>(collection: T[], item: T): (T)[] {
    const index = indexOf(collection, item);
    if (index !== -1) {
        return without(collection, item);
    }
    return [...collection, item];
}

export function isObject(x: any): boolean {
    return typeof x === 'object' && !Array.isArray(x) && x !== null
}

export function getArrayDifference<T extends { id: number }>(arr1: T[], arr2: T[]): T[] {
    let elements = arr1.filter((obj1: T) => {

        let objOld = arr2.find(i => i.id === obj1.id)

        let keysNew = Object.values(obj1)
        let keysOld: any[] = []
        if (objOld) {
            keysOld = Object.values(objOld)
        }

        let result1 = differenceWith(keysNew, keysOld, isEqual);
        if (!isEmpty(result1)) {
            return obj1
        }
    }

    );

    return elements
}
// Utility: binary search helper
export function binarySearch(arr: number[], target: number, findFirst: boolean): number {
  let low = 0, high = arr.length - 1, result = -1;
  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    if (arr[mid] < target) {
      low = mid + 1;
    } else if (arr[mid] > target) {
      high = mid - 1;
    } else {
      result = mid;
      if (findFirst) high = mid - 1;
      else low = mid + 1;
    }
  }
  return findFirst ? low : high;
}